import z from 'zod';

export const tradeTagDbSchema = z.object({
  label: z.string().min(1),
  description: z.string().optional(),
});

export interface TradeTagDb extends z.infer<typeof tradeTagDbSchema> {}
